(() => {
  const CONTENT_SELECTOR = '.licohenna-article__content';
  const CTA_CLASS = 'licohenna-article__cta';
  const CTA_LINK_CLASS = 'licohenna-article__cta-link';
  const CTA_ARROW_CLASS = 'licohenna-article__cta-arrow';

  const leftoverWithoutAnchor = (paragraph, anchor) =>
    [...paragraph.childNodes]
      .filter((node) => node !== anchor)
      .map((node) => node.textContent || '')
      .join('')
      .replace(/\s+/g, '');

  const isDirectCtaParagraph = (paragraph) => {
    if (!(paragraph instanceof HTMLParagraphElement)) return false;
    if (paragraph.classList.contains(CTA_CLASS)) return false;
    if (paragraph.querySelector('img, ul, ol, blockquote, h2, h3, strong, b, em')) return false;

    const elementChildren = [...paragraph.children].filter((el) => el.tagName !== 'META');
    if (elementChildren.length !== 1 || elementChildren[0].tagName !== 'A') return false;

    const anchor = elementChildren[0];
    if (anchor.textContent.replace(/\s+/g, '') === '') return false;
    if (leftoverWithoutAnchor(paragraph, anchor) !== '[]') return false;

    return true;
  };

  const stripBracketText = (paragraph) => {
    [...paragraph.childNodes].forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) return;

      const cleaned = node.textContent.replace(/[\[\]]/g, '');
      if (cleaned.replace(/\s+/g, '') === '') {
        node.remove();
        return;
      }

      node.textContent = cleaned;
    });
  };

  const appendArrow = (anchor, arrowSrc) => {
    if (!arrowSrc || anchor.querySelector(`.${CTA_ARROW_CLASS}`)) return;

    const arrow = document.createElement('img');
    arrow.className = CTA_ARROW_CLASS;
    arrow.src = arrowSrc;
    arrow.alt = '';
    arrow.width = 21;
    arrow.height = 19;
    arrow.setAttribute('aria-hidden', 'true');
    anchor.appendChild(arrow);
  };

  const enhanceParagraph = (paragraph, arrowSrc) => {
    if (!isDirectCtaParagraph(paragraph)) return;

    const anchor = [...paragraph.children].find((el) => el.tagName === 'A');
    if (!anchor) return;

    stripBracketText(paragraph);
    paragraph.classList.add(CTA_CLASS);
    anchor.classList.add(CTA_LINK_CLASS);
    appendArrow(anchor, arrowSrc);
  };

  const enhanceRoot = (root) => {
    if (!(root instanceof Element)) return;

    const arrowSrc = root.getAttribute('data-cta-arrow') || '';
    root.querySelectorAll('p').forEach((paragraph) => {
      enhanceParagraph(paragraph, arrowSrc);
    });
  };

  const enhanceAll = () => {
    document.querySelectorAll(CONTENT_SELECTOR).forEach(enhanceRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
  } else {
    enhanceAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.(CONTENT_SELECTOR);
    if (root) enhanceRoot(root);
    else enhanceAll();
  });
})();
